import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import leavesImage from "./leaves.png";

const LeaveBackground: React.FC = () => {
  const [isDark, setIsDark] = useState(false);
  const [isAnimationReady, setIsAnimationReady] = useState(false);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.code === "Space") {
        setIsDark((prev) => !prev);
      }
    };

    window.addEventListener("keypress", handleKeyPress);
    setIsAnimationReady(true);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  const containerClasses = [
    styles.container,
    isAnimationReady ? styles.animationReady : "",
    isDark ? styles.dark : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      <div id={styles.dappledLight}>
        <div id={styles.glow}></div>
        <div id={styles.glowBounce}></div>
        <div className={styles.perspective}>
          <div id={styles.leaves}>
            <svg style={{ width: 0, height: 0, position: "absolute" }}>
              <defs>
                <filter id="wind" x="-20%" y="-20%" width="140%" height="140%">
                  <feTurbulence type="fractalNoise" numOctaves="2" seed="1">
                    <animate
                      attributeName="baseFrequency"
                      dur="16s"
                      keyTimes="0;0.33;0.66;1"
                      values="0.005 0.003;0.01 0.009;0.008 0.004;0.005 0.003"
                      repeatCount="indefinite"
                    />
                  </feTurbulence>
                  <feDisplacementMap in="SourceGraphic">
                    <animate
                      attributeName="scale"
                      dur="20s"
                      keyTimes="0;0.25;0.5;0.75;1"
                      values="45;55;75;55;45"
                      repeatCount="indefinite"
                    />
                  </feDisplacementMap>
                </filter>
              </defs>
            </svg>
          </div>
          <div id={styles.blinds}>
            <div className={styles.shutters}>
              {Array(23)
                .fill(null)
                .map((_, index) => (
                  <div key={index} className={styles.shutter}></div>
                ))}
            </div>
            <div className={styles.vertical}>
              <div className={styles.bar}></div>
              <div className={styles.bar}></div>
            </div>
          </div>
        </div>
        <div id={styles.progressiveBlur}>
          {Array(4)
            .fill(null)
            .map((_, index) => (
              <div key={index}></div>
            ))}
        </div>
      </div>

      {/* <article className={styles.article}>
        <h1>sunlit</h1>
        <p>
          inspired by{" "}
          <a href="https://daylightcomputer.com/">daylight computer</a> and{" "}
          <a href="https://www.chloeyan.me/">chloe yan&apos;s</a>{" "}
          <a href="https://www.sunlit.place/">sunlit place</a>
        </p>
        <pre>
          [press <code>space</code> to toggle the sun]
        </pre>
      </article> */}
    </div>
  );
};

export default LeaveBackground;
